export default "__VITE_PUBLIC_ASSET__77831d78__"